module.exports = __webpack_public_path__ + "img/15.d1114dd5.jpg";